import { PlaceActivationResult as PlaceActivationResultDto } from 'gleblu-socket-api';

import PlaceActivationResult from '../interfaces/PlaceActivationResult';

export function fromDto(placeActivationResultDto: PlaceActivationResultDto): PlaceActivationResult {
  return PlaceActivationResult[placeActivationResultDto];
}

export function toDto(_: PlaceActivationResult): PlaceActivationResultDto {
  throw new Error('Not supported');
}
